import React, { useEffect, useState, useRef } from "react";
import { Box, Card, Typography, Skeleton, Button, CardMedia, Avatar, IconButton, Chip } from "@mui/material";
import { Briefcase, ArrowRight, DollarSign, ChevronLeft, ChevronRight, ExternalLink } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../context/AuthContext";
import ProPlanModal from "../../../../components/pro/ProPlanModal";

const ProfessionalServices = () => {
  const { user } = useAuth();
  const userId = user?.user_id || user?.id;
  const [services, setServices] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isProModalOpen, setIsProModalOpen] = useState(false);
  const [trialVencido, setTrialVencido] = useState(false);
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  const verificarProActivo = () => {
    try {
      const raw = localStorage.getItem("hitpoly_trial");
      if (raw) {
        const t = JSON.parse(raw);
        if (t && t.fin && new Date(t.fin).getTime() > Date.now()) return true;
      }
    } catch (e) {}
    return false;
  };
  const proActivo = verificarProActivo();

  useEffect(() => {
    const uid = user?.user_id || user?.id || 1500;
    // Siempre consultar API (incluso con uid 1500)
    fetch("https://apiweb.hitpoly.com/ajax/trialsController.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ accion: "estado", usuario_id: uid }),
    })
      .then((r) => r.json())
      .then((d) => {
        console.log("[ProfessionalServices] Respuesta API:", d);
        const rawLocal = localStorage.getItem("hitpoly_trial");
        const finFuture = (d && d.fin && new Date(d.fin).getTime() > Date.now());
        const activoReal = (d && d.status === "success" && (d.activo || finFuture));
        if (activoReal) {
          console.log("[ProfessionalServices] Pro ACTIVO (API).");
          setTrialVencido(false);
        } else if (d && d.status === "success" && !d.activo) {
          console.log("[ProfessionalServices] Pro INACTIVO (API).");
          try {
            if (rawLocal) {
              const t = JSON.parse(rawLocal);
              if (t && t.fin && new Date(t.fin).getTime() <= Date.now()) {
                console.log("[ProfessionalServices] Prueba vencida en localStorage.");
                localStorage.removeItem("hitpoly_trial");
                setTrialVencido(true);
              } else {
                console.log("[ProfessionalServices] No hay prueba vencida (nunca tuvo o limpia).");
                localStorage.removeItem("hitpoly_trial");
                setTrialVencido(false);
              }
            } else {
              console.log("[ProfessionalServices] No hay localStorage pero API tiene fin.");
              setTrialVencido(!!(d && d.fin));
            }
          } catch (e) {
            console.log("[ProfessionalServices] Error evaluando localStorage:", e);
            localStorage.removeItem("hitpoly_trial");
            setTrialVencido(false);
          }
        } else {
          console.log("[ProfessionalServices] API no devolvió success. Datos:", d);
          try {
            if (rawLocal) {
              const t = JSON.parse(rawLocal);
              if (t && t.fin && new Date(t.fin).getTime() <= Date.now()) {
                localStorage.removeItem("hitpoly_trial");
                setTrialVencido(true);
              } else {
                localStorage.removeItem("hitpoly_trial");
                setTrialVencido(false);
              }
            } else {
              setTrialVencido(false);
            }
          } catch (e) {
            setTrialVencido(false);
          }
        }
      })
      .catch((err) => {
        console.log("[ProfessionalServices] Error en fetch de Pro:", err);
        try {
          const raw = localStorage.getItem("hitpoly_trial");
          if (raw) {
            const t = JSON.parse(raw);
            if (t && t.fin && new Date(t.fin).getTime() > Date.now()) {
              setTrialVencido(false);
            } else {
              localStorage.removeItem("hitpoly_trial");
              setTrialVencido(!!raw);
            }
          } else {
            setTrialVencido(false);
          }
        } catch (e) {
          setTrialVencido(false);
        }
      });
  }, [user?.user_id, user?.id]);

  const scrollLeft = () => {
    if (scrollRef.current) scrollRef.current.scrollBy({ left: -220, behavior: 'smooth' });
  };

  const scrollRight = () => {
    if (scrollRef.current) scrollRef.current.scrollBy({ left: 220, behavior: 'smooth' });
  };

  useEffect(() => {
    fetch("https://apiweb.hitpoly.com/ajax/communityWidgetsController.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "getProfessionalServices" })
    })
      .then(r => r.json())
      .then(d => {
        if (d.success && d.data && d.data.length > 0) {
          setServices(d.data);
        } else {
          setServices([]);
        }
      })
      .catch(() => setServices([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Skeleton variant="rectangular" height={220} sx={{ mb: 2, borderRadius: 4 }} />;
  if (!services || services.length === 0) return null;

  return (
    <>
    <Card sx={{
      mb: 3,
      bgcolor: "rgba(255,255,255,0.9)",
      backdropFilter: "blur(8px)",
      borderRadius: 4,
      border: '1px solid #f0f0f0',
      boxShadow: 'none',
      p: 2.5
    }}>
      {/* Encabezado del Carrusel */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="subtitle1" fontWeight="800" sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#1a1a1a' }}>
          <Briefcase size={18} color="#0a66c2" /> Servicios: Profesional
        </Typography>
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <IconButton size="small" onClick={scrollLeft} sx={{ bgcolor: '#f0f2f5', width: 28, height: 28 }}><ChevronLeft size={16} /></IconButton>
          <IconButton size="small" onClick={scrollRight} sx={{ bgcolor: '#f0f2f5', width: 28, height: 28 }}><ChevronRight size={16} /></IconButton>
        </Box>
      </Box>

      {/* Contenedor con Scroll Horizontal */}
      <Box ref={scrollRef} sx={{
        display: 'flex',
        gap: 2,
        overflowX: 'auto', className: 'community-wall-scroll', scrollbarWidth: 'thin', scrollbarColor: '#0B8DB5 transparent',
        pb: 1.5,
        mx: -0.5,
        px: 0.5,
        '&::-webkit-scrollbar': { height: 4 },
        '&::-webkit-scrollbar-track': { bgcolor: 'transparent' },
        '&::-webkit-scrollbar-thumb': { bgcolor: '#0B8DB5', borderRadius: 4, border: 0 }
      }}>
        {services.map(srv => (
          <Card key={srv.id} sx={{
            minWidth: 220,
            maxWidth: 220,
            borderRadius: 3,
            border: '1px solid #eef3f8',
            boxShadow: 'none',
            bgcolor: '#ffffff',
            cursor: 'pointer',
            transition: 'all 0.25s ease',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            '&:hover': {
              borderColor: '#0a66c2',
              boxShadow: '0 8px 25px rgba(10, 102, 194, 0.12)'
            }
          }} onClick={() => {
            console.log("[ProfessionalServices] Click en carta. srv.id:", srv.id, "proActivo:", proActivo, "trialVencido:", trialVencido, "userId:", userId);
            if (!proActivo) {
              console.log("[ProfessionalServices] Abriendo modal. proActivo:", proActivo, "trialVencido:", trialVencido);
              setIsProModalOpen(true);
              return;
            }
            const targetPath = `/systems/bolsa/servicio-profesional/${srv.id}?userId=${userId}`;
            navigate(targetPath);
          }}>

            {/* Contenedor de Imagen Limpio */}
            <Box sx={{ height: 100, bgcolor: '#f5f5f5', overflow: 'hidden' }}>
              {srv.image ? (
                <CardMedia component="img" height="100" image={srv.image} alt={srv.title} sx={{ transition: 'transform 0.3s ease', '&:hover': { transform: 'scale(1.05)' } }} />
              ) : (
                <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc' }}>
                  <Briefcase size={32} />
                </Box>
              )}
            </Box>

            {/* Contenido e Información */}
            <Box sx={{ p: 1.5, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="body2" fontWeight="800" color="#1a1a1a" sx={{ mb: 0.5, lineHeight: 1.3, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                {srv.title}
              </Typography>

              {/* Chips de Categoría y Modalidad */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap', mb: 1 }}>
                {srv.categoria && (
                  <Chip label={srv.categoria} size="small" sx={{ height: 18, fontSize: '0.6rem', fontWeight: 600, bgcolor: '#eef3f8', color: '#0a66c2' }} />
                )}
                {srv.modalidad && (
                  <Chip label={srv.modalidad} size="small" sx={{ height: 18, fontSize: '0.6rem', fontWeight: 600, bgcolor: '#f0fdf4', color: '#16a34a' }} />
                )}
              </Box>

              {/* Pie de la tarjeta alineado al fondo */}
              <Box sx={{ mt: 'auto', pt: 0.5, display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }}>

                {/* Izquierda: Info Profesional y Precio */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, overflow: 'hidden', flex: 1 }}>
                  {srv.profesional_nombre && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                      <Avatar src={srv.profesional_avatar} sx={{ width: 18, height: 18, fontSize: '0.55rem', bgcolor: '#0a66c2', color: '#fff', fontWeight: 700 }}>
                        {srv.profesional_nombre.charAt(0)}
                      </Avatar>
                      <Typography variant="caption" color="text.secondary" fontWeight="600" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {srv.profesional_nombre}
                      </Typography>
                    </Box>
                  )}

                  {srv.price && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, fontWeight: 800, color: '#333', fontSize: '0.8rem' }}>
                      <DollarSign size={13} color="#16a34a" />
                      <Typography variant="caption" fontWeight="800" color="text.primary">
                        {srv.moneda || 'USD'} ${parseFloat(srv.price).toLocaleString()}
                      </Typography>
                    </Box>
                  )}
                </Box>

                {/* Derecha: Icono de enlace externo */}
                <ExternalLink size={13} color="#0a66c2" style={{ flexShrink: 0, marginLeft: 6 }} />

              </Box>
            </Box>

          </Card>
        ))}
      </Box>

      {/* Botón de Ver Todos */}
      <Button
        onClick={() => navigate('/servicios-profesionales')}
        sx={{
          width: '100%',
          mt: 1,
          textTransform: 'none',
          fontWeight: '700',
          color: '#0a66c2',
          '&:hover': { bgcolor: '#eef3f8' }
        }}
        endIcon={<ArrowRight size={16} />}
      >
        Explarar servicios
      </Button>
    </Card>

    <ProPlanModal
      open={isProModalOpen}
      vencido={trialVencido}
      onClose={() => setIsProModalOpen(false)}
      herramienta="Servicios Profesionales"
    />
    </>
  );
};

export default ProfessionalServices;

